export const API_CONFIG = {
  LOGIN: "/usermgmt/public/ib/login/verify",
  RESEND_OTP: "/usermgmt/public/register/resendOtp",
  SIGNUP_VERIFY: "/usermgmt/public/register/verify",
  SIGNUP_CONFIRM: "/usermgmt/public/register/confirm",
  SIGNUP_USERNAME_CHECK: "/usermgmt/public/register/usernamecheck",
  FORGOT_PASSWORD_VERIFY: "/usermgmt/public/forgot/pwd/verify",
  FORGOT_PASSWORD_CONFIRM: "/usermgmt/public/forgot/pwd/confirm",
  internetloginverify: "/usermgmt/public/ib/login/confirm",
  LOGOUT: "/usermgmt/public/ib/logout",
  userfaq: "/bankinfo/public/information/userfaq",
  metadata: "/bankinfo/public/information/metadata",
  PUBLIC_KEY_GENERATION: "/bankinfo/public/information/generate",
  forgotUserIdVerify: "/usermgmt/public/usercred/forgotUserIdVerify",
  forgotUserIdConfirm: "/usermgmt/public/usercred/forgotUserIdConfirm",
  getLocations: "/bankinfo/public/information/getLocations",
  getPrivacyPolicy: "/usermgmt/public/getprivacypolicy",
  getSecurityTips: "/usermgmt/public/gettermsAndConditions",
  getMyActivity: "/usermgmt/profile/getMyActivity",
  profileDetails: "/usermgmt/profile/profileDetails",
  setQestions: "/usermgmt/securityQuestions/setQestions",
  setQestionsSkip: "/usermgmt/securityQuestions/setQestionsSkip",
  getQestionsAndAnswer: "/usermgmt/securityQuestions/getQestionsAndAnswers",
  getSecurityQuestions: "/bankinfo/public/information/securityquestions",
  getQuickAccounts: "/accountmgmt/accounts/getQuickAccounts",
  getAccountSummary: "/accountmgmt/accounts/getAccountSummary",
  upComingInComing: "/servicerequest/payments/upComingInComing",
  upComingPayments: "/servicerequest/payments/upComingPayments",
  getBalanceEnquiry: "/accountmgmt/accounts/getBalanceEnquiry",
  getCustomerTxnList: "/ftmgmt/custTxn/getCustTxnLimits",
  updateTransactionLimit: "/ftmgmt/custTxn/updateCustTxnLimit",
  deRegistration: "/usermgmt/userActivity/deRegistration",
  blockMyLogin: "/usermgmt/profile/blockMyLogin",
  setPrimaryAccount: "/accountmgmt/accounts/setPrimaryAccount",
  updateCustomerTxnLimits: "/usermgmt/customerTxn/updateCustomerTxnLimits",
  getLastNTransactions: "/accountmgmt/accounts/getMiniStatement",
  editMinistatement: "/accountmgmt/accounts/tagRemarksToTxn",
  editAccShortName: "/accountmgmt/accounts/editAccShortName",
  tdAccInq: "/usermgmt/deposit/tdAccInq",
  getfullacctstmtwithpagination: "/accountmgmt/accounts/fullStatement",
  getBankDetails: "/ftmgmt/beneficiary/getBankDetails",
  ifscBranchDetails: "/ftmgmt/beneficiary/getBranchDetails",
  getIfscCode: "/ftmgmt/beneficiary/getIfscCode",
  getWithinBankAccDetails: "/ftmgmt/fundtransfer/getWithinBankAccDetails",
  addPayeeVerify: "/ftmgmt/beneficiary/add/verify",
  addPayeeConfirm: "/ftmgmt/beneficiary/add/confirm",
  getAllPayee: "/ftmgmt/beneficiary/getAll",
  transferOptions: "/ftmgmt/fundtransfer/getTransferOptions",
  verify: "/ftmgmt/fundtransfer/initVerify",
  confirm: "/ftmgmt/fundtransfer/initConfirm",
  viewScheduledTransfers: "/ftmgmt/transactions/viewScheduledTransfers",
  modifyOrCancelScheduledTransferVerify:
    "/ftmgmt/transactions/cancelScheduledTransferVerify",
  modifyOrCancelScheduledTransferConfirm:
    "/ftmgmt/transactions/cancelScheduledTransferConfirm",
  getPendingRecords: "/usermgmt/fundtransfer/getPendingRecords",
  forceChangePasswordVerify: "/usermgmt/public/change/pwd/verify",
  forceChangePasswordConfirm: "/usermgmt/public/change/pwd/confirm",
  getAccountSummaryByAccNo: "/accountmgmt/accounts/getCaSaAccountDetails",
  getDepositAccountSummaryByAccNo:
    "/accountmgmt/accounts/getDepositAccountDetails",
  getLoanAccountSummaryByAccNo: "/accountmgmt/accounts/getLoanAccountDetails",
  tdAccInq: "/usermgmt/deposit/tdAccInq",
  getEStatementsDetails: "/servicerequest/eStatements/getEStatementsDetails",
  createOrUpdate: "/servicerequest/eStatements/createOrUpdate",
  fullStatementPagination: "/accountmgmt/accounts/fullStatement",
  openFdOrRdConfirm: "/deposit/deposit/openDepositConfirm",
  openFdOrRdVerify: "/deposit/deposit/openDepositVerify",
  getNomineeDetails: "/deposit/deposit/getNomineeList",
  getProducts: "/deposit/deposit/getProducts",
  chequeDetails: "/servicerequest/chequeBook/getChequeDetails",
  chqIssuedByMeSummary:
    "/servicerequest/chequeDepositIssuedReq/chqIssuedorDepositedByMeSummary",
  chqDepositedByMeSummary:
    "/servicerequest/chequeDepositIssuedReq/chqIssuedorDepositedByMeSummary",
  chqIssuedByMeDetails:
    "/servicerequest/chequeDepositIssuedReq/chqIssuedorDepositedByMeDetails",
  chqDepositedByMeDetails:
    "/servicerequest/chequeDepositIssuedReq/chqIssuedorDepositedByMeDetails",
  chequeBookChequesStatus:
    "/servicerequest/chequeStatus/chequeBookChequesStatus",
  stopChequeverify: "/servicerequest/stopCheque/initVerify",
  stopChequeConfirm: "/servicerequest/stopCheque/initConfirm",
  getDashboardAccSummaryByDate:
    "/accountmgmt/accounts/getDashboardAccSummaryByDate",
  statementDownload: "/accountmgmt/accounts/statementDownload",
  statementExcelDownload: "/accountmgmt/accounts/statementDownloadExcel",
  emailStatement: "/accountmgmt/accounts/emailStatement",
  changeUsernameVerify: "/usermgmt/public/changeUsernameVerify",
  usercredVerify: "usercred/username/change/verify",
  changeUsernameConfirm: "/usermgmt/public/changeUsernameConfirm",
  emailUpdate: "/usermgmt/profile/emailUpdate",
  DEPOSIT_ADVISE: "/usermgmt/receipt/tdstatement",
  leavesList: "/servicerequest/chequeBookRequest/leavesList",
  chequeBookVerification: "/servicerequest/chequeBookRequest/initVerify",
  chequeBookConfirmation: "/servicerequest/chequeBookRequest/initConfirm",
  changePasswordVerify: "/usermgmt/public/change/pwd/verify",
  changePasswrod: "/usermgmt/public/change/pwd/confirm",
  addFavOwnAccount: "/usermgmt/payee/addFavOwnAccount",
  getFavouriteList: "/ftmgmt/beneficiary/getAllFavList",
  addFavouritePayee: "/ftmgmt/beneficiary/favourite/add",
  deletePayee: "/ftmgmt/beneficiary/remove/verify",
  deletePayeeConfirm: "/ftmgmt/beneficiary/remove/confirm",
  autoDisableDebitCard: "/servicerequest/debitCard/autoDisableDebitCard",
  debitCardStatusUpdate: "/servicerequest/debitCard/debitCardStatusUpdate",
  cardDetails: "/servicerequest/debitCard/cardDetails",
  newdebitCardRequestVerify: "/servicerequest/debitCard/debitCardRequestVerify",
  newdebitCardRequestConfirm:
    "/servicerequest/debitCard/debitCardRequestConfirm",
  requestAddOnCard: "/usermgmt/debitCard/requestAddOnCard",
  editProfileImage: "/usermgmt/profile/updateProfileImage",
  deleteProfileImage: "/usermgmt/profile/deleteProfileImage",
  blockAccount: "/accountmgmt/accounts/accountFreeze",
  forgotPwdVerify: "/usermgmt/public/forgot/pwd/verify",
  forgotPwdConfirm: "/usermgmt/public/forgot/pwd/confirm",
  unfreezAccount: "/usermgmt/profile/unfreezAccount",
  deRegister: "/usermgmt/userDeRegistration/deRegistration",
  authVerify: "/ftmgmt/fundtransfer/authVerify",
  authConfirm: "/ftmgmt/fundtransfer/authConfirm",
  reSubmitTransferVerify: "/usermgmt/fundtransfer/reSubmitTransferVerify",
  reSubmitTransferConfirm: "/usermgmt/fundtransfer/reSubmitTransferConfirm",
  cardLimitUpdate: "/servicerequest/debitCard/cardLimitUpdate",
  cardLimitUpdateVerify: "/servicerequest/debitCard/limitUpdate/verify",
  cardLimitUpdateConfirm: "/servicerequest/debitCard/limitUpdate/confirm",
  channelAccUpdate: "/usermgmt/debitCard/channelAccUpdate",
  isEligibleToOpenTDAccount: "/usermgmt/deposit/isEligibleToOpenTDAccount",
  getCityDetails: "/deposit/deposit/getCityDetails",
  getCustImpNotifications:
    "/bankinfo/public/information/getCustImpNotifications",
  addAsPayee: "/usermgmt/fundtransfer/addAsPayee",
  pinCodeSerach: "/servicerequest/chequeBookRequest/pinCodeSearch",
  getNACHMandateDetails: "/usermgmt/profile/getNACHMandateDetails",
  nachMandate: "/usermgmt/profile/nachMandate",
  acctLienAddVerify: "/usermgmt/acctLien/acctLienAddVerify",
  acctLienAddComfirm: "/usermgmt/acctLien/acctLienAddConfirm",
  acctLienModifyVerify: "/usermgmt/acctLien/acctLienModifyVerify",
  acctLienModifyComfirm: "/usermgmt/acctLien/acctLienModifyConfirm",
  acctLienInq: "/usermgmt/acctLien/acctLienInq",
  doNotSendSMSInfo: "/usermgmt/userActivity/doNotSendSMSInfo",
  getDoNotSendSMSList: "/usermgmt/userActivity/getDoNotSendSMSList",
  doNotSendSMSSaves: "/userActivity/doNotSendSMSSave",
  getLoanRequestValues: "/servicerequest/loanRequest/getLoanRequestValues",
  loanRequestVerify: "/servicerequest/loanRequest/initVerify",
  loanRequestConfirm: "/servicerequest/loanRequest/initConfirm",
  registerVerify: "/usermgmt/public/register/verify",
  registerConfirm: "/usermgmt/public/register/confirm",
  createCASAAccountVerify: "/accountmgmt/accCreate/verify",
  createCASAAccountConfirm: "/accountmgmt/accCreate/confirm",
  getAccountClasses: "/accountmgmt/accountClass/getAccountClasses",
  getBalances: "/accountmgmt/accounts/getBalances",
  getallExchangeRates: "/bankinfo/public/information/getCrossCurrencyRates",
  calculateLoanDepositResult: "/bankinfo/public/information/calLoanDep",
  updatePayeeImage: "/ftmgmt/beneficiary/updateBeneImage",
  getPayeeImages: "/ftmgmt/beneficiary/getBeneImages",
  modifyPayeeVerify: "/ftmgmt/beneficiary/modify/verify",
  modifyPayeeConfirm: "/ftmgmt/beneficiary/modify/confirm",
  getAllCountryCodes: "/ftmgmt/beneficiary/getAllCountryCodes",
  removePayeeImage: "/ftmgmt/beneficiary/removeBeneImage",
  getTermsAndConditions: "/bankinfo/public/information/gettermsAndConditions",
  getLoanAccountStatement:
    "/servicerequest/loanRequest/getLoanAccountStatement",
  siList: "/servicerequest/si/getRecords",
  siView: "/servicerequest/viewSi",
  siCreateVerify: "/servicerequest/createSI/verify",
  siCreateConfirm: "/servicerequest/createSI/confirm",
  siAuthVerify: "/servicerequest/createSI/authVerify",
  siAuthConfirm: "/servicerequest/createSI/authConfirm",
  linkAccountVerify: "/accountmgmt/accounts/linkVerify",
  linkAccountConfirm: "/accountmgmt/accounts/linkConfirm",
  DeLinkAccountVerify: "/accountmgmt/accounts/delinkVerify",
  DeLinkAccountConfirm: "/accountmgmt/accounts/delinkConfirm",
  getStopchequeReasonList: "/servicerequest/stopCheque/getReasonList",
  generateTokenVerify: "/ftmgmt/cardlesscash/generateToken/verify",
  generateTokenConfirm: "/ftmgmt/cardlesscash/generateToken/confirm",
  getTokenRecords: "/ftmgmt/cardlesscash/getRecords",
  tokenAuthVerify: "/ftmgmt/cardlesscash/generateToken/authVerify",
  tokenAuthConfirm: "/ftmgmt/cardlesscash/generateToken/authConfirm",
  viewToken: "/ftmgmt/cardlesscash/viewToken",
  cancelToken: "/ftmgmt/cardlesscash/cancelToken",
  addBillerBeneVerify: "/billpay/billerBeneficiary/addVerify",
  addBillerBeneConfirm: "/billpay/billerBeneficiary/addConfirm",
  addautopayverify: "/billerBene/modifyBillerBeneficiaryVerify",
  autopaydeleteverify: "/billerBene/modifyBillerBeneficiaryVerify",
  autopaydeleteConfirm: "/billerBene/modifyBillerBeneficiaryConfirm",
  addautopayconfirm: "/billerBene/modifyBillerBeneficiaryConfirm",
  modifyBillerBeneVerify: "/billpay/billerBeneficiary/modifyVerify",
  modifyBillerBeneConfirm: "/billpay/billerBeneficiary/modifyConfirm",
  getBillerBeneficiary: "/billpay/billerBeneficiary/getBillerBeneficiary",
  deleteBillerBeneficiaryVerify: "/billpay/billerBeneficiary/deleteVerify",
  deleteBillerBeneficiaryConfirm: "/billpay/billerBeneficiary/deleteConfirm",
  bpVerify: "/billpay/billPayment/verify",
  billPay: "/billpay/billPayment/confirm",
  getPendingRecords: "/billPayment/getPendingRecords",
  bpAuthVerify: "/billPayment/bpAuthVerify",
  bpAuthConfirm: "/billPayment/bpAuthConfirm",
  bpReSubmitVerify: "/billPayment/bpReSubmitVerify",
  bpReSubmitConfirm: "/billPayment/bpReSubmitConfirm",
  billerCategories: "/billpay/billerBeneficiary/billerCategories",
  billersByCategory: "/billpay/billerBeneficiary/billersByCategory",
  getCustomerParamsByBillerId:
    "/billpay/billerBeneficiary/getCustomParamsByBillerId",
  getPendingBills: "/billpay/billPayment/PendingBills",
  getPrivacyPolicy: "/bankinfo/public/information/getprivacypolicy",
  addInternatinalPayeeVerify: "/ftmgmt/beneficiary/add/internationalVerify",
  addInternatinalPayeeConfirm: "/ftmgmt/beneficiary/add/internationalConfirm",
  accountLookUp: "/ftmgmt/fundtransfer/accLookUp",
  modifyInternatinalPayeeVerify:
    "/ftmgmt/beneficiary/modify/internationalVerify",
  modifyInternatinalPayeeConfirm:
    "/ftmgmt/beneficiary/modify/internationalConfirm",
  getTxnCurrency: "/ftmgmt/fundtransfer/currencyList",
  getFspCodes: "/ftmgmt/fundtransfer/getFspCodes",
  getEAPBankList: "/ftmgmt/fundtransfer/getEAPBankList",
  getFileProcessList: "/ftmgmt/fileUpload/getFileProcessList",
  downloadTemplate: "/ftmgmt/fileUpload/downloadTemplate",
  fileInternationalUpload: "/ftmgmt/fundtransfer/internationalFtFileUpload",
  fileUploadInitVerify: "ftmgmt/fileUpload/initVerify",
  fileUploadInitConfirm: "/ftmgmt/fileUpload/initConfirm",
  fileUploadGetRecords: "/ftmgmt/fileUpload/getRecords",
  fileUploadAuthVerify: "/ftmgmt/fileUpload/authVerify",
  fileUploadAuthConfirm: "/ftmgmt/fileUpload/authConfirm",
  fileUploadPendingCount: "/ftmgmt/fileUpload/getPendingCount",
  ftGetRecords: "/ftmgmt/fundtransfer/getRecords",
  ftPendingCount: "/ftmgmt/fundtransfer/getFTPendingCount",
  paymentPendingCount: "/billpay/billPayment/getAuthorizerPendingCount",
  getRemarks: "/ftmgmt/fundtransfer/getRemarks",
  getBillPaymentList: "/billpay/billPayment/search",
  getBillerCategories: "/billpay/billerBeneficiary/billerCategories",
  getBillersByCategory: "/billpay/billerBeneficiary/billersByCategory",
  getBillerBeneficiary: "/billpay/billerBeneficiary/getBillerBeneficiary",
  viewBillerList: "/billpay/billerBeneficiary/getBillerBeneficiary",
  getConvertedAmount: "/ftmgmt/fundtransfer/getConvertedAmount",
  deleteBillerVerify: "/billpay/billerBeneficiary/deleteVerify",
  deleteBillerConfirm: "/billpay/billerBeneficiary/deleteConfirm",
  getCustomParamsByBillerId:
    "/billpay/billerBeneficiary/getCustomParamsByBillerId",
  billPaymentVerify: "/billpay/billPayment/verify",
  billPaymentConfirm: "/billpay/billPayment/confirm",
  beneficiaryGetRecords: "/ftmgmt/beneficiary/getRecords",
  beneficiaryPendingCount: "/ftmgmt/beneficiary/getBenePendingCount",
  beneAuthVerify: "/ftmgmt/beneficiary/auth/verify",
  beneAuthConfirm: "/ftmgmt/beneficiary/auth/confirm",
  beneDelete: "/ftmgmt/beneficiary/deleteInitRecord",
  beneDownload: "/ftmgmt/beneficiary/beneRecordsDownload",
  bulkTransferVerify: "/ftmgmt/fundtransfer/bulk/initverify",
  bulkTransferConfirm: "/ftmgmt/fundtransfer/bulk/initconfirm",
  downloadFileUploadStatusRecord:
    "/ftmgmt/fileUpload/downloadFileUploadStatusRecord",
  downloadFileProcessList: "/ftmgmt/fileUpload/downloadFileProcessList",
  getAllOffers: "/bankinfo/public/information/getAllOffers",
  getAboutUs: "/bankinfo/public/information/getAboutUs",
  addBillerVerify: "/billpay/billerBeneficiary/addVerify",
  paymentGetRecords: "/billpay/billPayment/getRecords",
  paymentAuthVerify: "/billpay/billPayment/authVerify",
  paymentAuthConfirm: "/billpay/billPayment/authConfirm",
  salaryUploadPendingCount: "/ftmgmt/fileUpload/getPendingCount",
  salaryUploadGetRecords: "/ftmgmt/fileUpload/getRecords",
  salaryUploadAuthVerify: "/ftmgmt/fileUpload/authVerify",
  salaryUploadAuthConfirm: "/ftmgmt/fileUpload/authConfirm",
  getbillQuote: "/billpay/billPayment/billQuote",
  addBillerConfirm: "/billpay/billerBeneficiary/addConfirm",
  ftDelete: "/ftmgmt/fundtransfer/deleteInitRecord",
  salaryUploadDelete: "/ftmgmt/fileUpload/deleteInitRecord",
  paymentDelete: "/billpay/billPayment/deleteInitRecord",
  gepegDelete: "/gepg/gepgPay/deleteInitRecord",
  billerBeneDelete: "/billpay/billerBeneficiary/deleteInitRecord",
  billerBeneficiaryPendingCount:
    "/billpay/billerBeneficiary/getAuthorizerPendingCount",
  billerBeneficiaryRecords: "/billpay/billerBeneficiary/getRecords",
  billerBeneficiaryAuthVerify: "/billpay/billerBeneficiary/authVerify",
  billerBeneficiaryAuthConfirm: "/billpay/billerBeneficiary/authConfirm",
  getFeedbackCategory: "/bankinfo/feedback/getComplaintFeedbackCatg",
  createFeedback: "/bankinfo/feedback/create",
  billerDownload: "/billpay/billerBeneficiary/billerBeneRecordsDownload",
  paymentDownload: "/billpay/billPayment/billPaymentRecordsDownload",
  ftDownload: "/ftmgmt/fundtransfer/ftRecordsDownload",
  fileUploadDownload: "/ftmgmt/fileUpload/fileRecordsDownload",
  transactionHistory: "/ftmgmt/fundtransfer/search",
  paymentHistory: "/billpay/billPayment/search",
  downloadReceipts: "/ftmgmt/fundtransfer/downloadReceipts",
  downloadPaymentReceipts: "/billpay/billPayment/downloadReceipts",
  gepg_billEnquiry: "/gepg/gepgPay/billEnquiry",
  gepg_initVerify: "/gepg/gepgPay/initVerify",
  gepg_initConfirm: "/gepg/gepgPay/initConfirm",
  gepg_authVerify: "/gepg/gepgPay/authVerify",
  gepg_authConfirm: "/gepg/gepgPay/authConfirm",
  gepg_getRecords: "/gepg/gepgPay/getRecords",
  forgotUsernameVerify: "/usermgmt/public/forgotUserName/verify",
  forgotUsernameConfirm: "/usermgmt/public/forgotUserName/confirm",
  getIdentityTypes: "/admin/public/register/identity",
  fileSingleRecordDownload: "/ftmgmt/fileUpload/downloadFileUploadStatusRecord",
  gepg_pendingCounts: "/gepg/gepgPay/getGepgPendingCount",
  gepg_Download: "/gepg/gepgPay/authPendingRecordsDownload",
  salaryDownloadRecords: "/ftmgmt/fileUpload/salaryDownloadRecords",
  selfUnLockVerify: "/usermgmt/public/selfunlock/verify",
  selfUnLockConfirm: "/usermgmt/public/selfunlock/confirm",
  viewScheduledPayments: "/billpay/scheduledPayments/viewScheduledPayments",
  modifyOrCancelScheduledPaymentsVerify:
    "/billpay/scheduledPayments/cancelScheduledPaymentVerify",
  modifyOrCancelScheduledPaymentsConfirm:
    "/billpay/scheduledPayments/cancelScheduledPaymentConfirm",
  rePaymentVerify: "/ftmgmt/fundtransfer/reSubmitTransferVerify",
  rePaymentConfirm: "/ftmgmt/fundtransfer/reSubmitTransferConfirm",
  getAllCardProducts: "/servicerequest/debitCard/getAllCardProducts",
  debitCardDetails: "/servicerequest/debitCard/cardDetails",
  debitCardRequestVerify: "/servicerequest/debitCard/debitCardRequestVerify",
  debitCardRequestConfirm: "/servicerequest/debitCard/debitCardRequestConfirm",
  debitCardAuthVerify: "/servicerequest/debitCard/debitCardAuthVerify",
  debitCardAuthConfirm: "/servicerequest/debitCard/debitCardAuthConfirm",
  debitCardDelete: "/servicerequest/debitCard/delete",
  debitCardGetRecords: "/servicerequest/debitCard/getRecords",
  debitCardAuthorizerPendingCount:
    "/servicerequest/debitCard/getAuthorizerPendingCount",
  debitCardRecDownload: "/servicerequest/debitCard/debitCardRecDownload",
  getInitiatorPendingCount: "/usermgmt/userDashBoard/getInitiatorPendingCount",
  getConsolidatedCount: "/servicerequest/dashboard/getConsolidatedCount",
  getFTConsolidatedCount: "/ftmgmt/dashboard/getConsolidatedCount",
  swiftCodeLookUp: "/ftmgmt/fundtransfer/swiftCodeLookUp",
  swiftCountryLookUp: "/ftmgmt/fundtransfer/getswiftcountrylookup",
  gepg_History: "/gepg/gepgPay/search",
  modifyBillerVerify: "/billpay/billerBeneficiary/modifyVerify",
  modifyBillerConfirm: "/billpay/billerBeneficiary/modifyConfirm",
  chequeBookAuthVerify: "/servicerequest/chequeBookRequest/authVerify",
  chequeBookAuthConfirm: "/servicerequest/chequeBookRequest/authConfirm",
  chequeBookDelete: "/servicerequest/chequeBookRequest/delete",
  chequeBookGetRecords: "/servicerequest/chequeBookRequest/getRecords",
  chequeStatusVerify: "/servicerequest/chequeStatus/verify",
  chequeStatusConfirm: "/servicerequest/chequeStatus/confirm",
  chequeBookAuthorizerPendingCount:
    "/servicerequest/chequeBookRequest/getAuthorizerPendingCount",
  chequeBookRecDownload: "/servicerequest/chequeBookRequest/cbRecDownload",
  stopChequeAuthVerify: "/servicerequest/stopCheque/authVerify",
  stopChequeAuthConfirm: "/servicerequest/stopCheque/authConfirm",
  stopChequeDelete: "/servicerequest/stopCheque/deleteInitRecord",
  stopChequeGetRecords: "/servicerequest/stopCheque/getRecords",
  stopChequeRecDownload: "/servicerequest/stopCheque/downloadRecords",
  getLoanDisbursement: "/servicerequest/loan/disbursement",
  getLoanStatement: "/servicerequest/loan/getLoanAccountStatement",
  loanscheduleinq: "/servicerequest/loan/scheduleinq",
  getLcreport: "/servicerequest/tradeFinance/getLcreport",
  getBgreport: "/servicerequest/tradeFinance/getBgreport",
  getBillunderlcreport: "/servicerequest/tradeFinance/getBillunderlcreport",
  getLcreport: "/servicerequest/tradeFinance/getLcreport",
  getBgreport: "/servicerequest/tradeFinance/getBgreport",
  getBillunderlcreport: "/servicerequest/tradeFinance/getBillunderlcreport",
  repaymentVerify: "/servicerequest/loanRepayment/initVerify",
  repaymentConfirm: "/servicerequest/loanRepayment/initConfirm",
  loanRepaymentGetRecords: "/servicerequest/loanRepayment/getRecords",
  loanRepaymentDownload: "/servicerequest/loanRepayment/downloadRecords",
  LoanRepaymentDelete: "/servicerequest/loanRepayment/deleteInitRecord",
  loanRepaymentAuthVerify: "/servicerequest/loanRepayment/authVerify",
  loanRepaymentAuthConfirm: "/servicerequest/loanRepayment/authConfirm",
  loanstatementDownload: "/servicerequest/loan/loanAccountStatementDownload",
  siGetRecords: "/servicerequest/si/getRecords",
  siDownload: "/servicerequest/si/siRecordsDownload",
  authSIVerify: "/servicerequest/createSI/authVerify",
  authSIConfirm: "/servicerequest/createSI/authConfirm",
  siCancelConfirm: "/servicerequest/cancelSi/confirm",
  siCancelVerify: "/servicerequest/cancelSi/verify",
  siDelete: "/servicerequest/si/deleteInitRecord",
  getPaymentConsolidatedCount: "/billpay/dashboard/getConsolidatedCount",
  deleteCardlessCash: "/ftmgmt/cardlesscash/delete",
  depositsGetRecords: "/deposit/deposit/getRecords",
  depositsDelete: "/deposit/deposit/delete",
  depositsAuthVerify: "/deposit/deposit/authVerify",
  depositsAuthConfirm: "/deposit/deposit/authConfirm",
  depositsDownload: "/deposit/deposit/TdRecordsDownload",
  refreshToken: "/usermgmt/public/refreshtoken",
  getQuickAccessMenu: "/bankinfo/public/information/getQuickAccessMenu",
  downloadGepgPaymentReceipts: "/gepg/gepgPay/downloadReceipts",

  getRegion: "/bankinfo/public/information/getregion",

  blockDebitCardVerify:
    "/servicerequest/blockDebitCard/blockDebitCardRequestVerify",
  blockDebitCardConfirm:
    "/servicerequest/blockDebitCard/blockdebitCardRequestConfirm",
  getAllCardFields: "/bankinfo-service/processFields/getFields",
  getinterestValues: "/bankinfo/public/information/interestValues",
  cardlessViewToken: "/ftmgmt/cardlesscash/viewToken",
  getsalaryAdvanceList:"/servicerequest/SalaryAdvance/salaryavdloanqueryinfo",
  salaryAdvanceLoanRequestVerify:"/servicerequest/SalaryAdvance/salaryavdloanreqverify",
  salaryAdvanceLoanRequestConfirm:"/servicerequest/SalaryAdvance/salaryavdloanreq",
  salaryAdvanceLoanRepayVerify:"/servicerequest/SalaryAdvance/salaryavdloanrepayverify",
  salaryAdvanceLoanRepayConfirm:"/servicerequest/SalaryAdvance/salaryavdloanrepay",
  getCharges: "/ftmgmt/fundtransfer/getCharges",
  pesaLinkAccount: "/ftmgmt/fundtransfer/pesaLinkPhoneLinkAndDeLink",
  getCountryCodes: "/bankinfo/public/information/getAllCountryCodes",
};
